import { Link } from 'react-router-dom';
import { Header } from '../components/Header';
import { XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#0B0B0B]" data-testid="payment-cancel-page">
      <Header />
      
      <main className="pt-24 px-4 sm:px-6 lg:px-8 pb-16">
        <div className="max-w-md mx-auto text-center">
          <div className="bg-[#141414] rounded-2xl p-8 border border-white/5">
            <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-yellow-500/20 flex items-center justify-center">
              <XCircle className="w-8 h-8 text-yellow-500" />
            </div>
            <h1 className="font-heading text-2xl font-bold uppercase text-white mb-3">
              Payment Cancelled
            </h1>
            <p className="text-gray-400 mb-6">
              Your payment was cancelled. No charges have been made.
            </p>
            <Link to="/">
              <Button className="bg-primary text-white hover:bg-primary/90">
                Back to Home
              </Button>
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}
